import './ExplorersJournalHeaderRow.styles.scss';
import { ExplorersJournalHeaderRowProps } from './ExplorersJournalHeaderRow.types';
import Dropdown from '../../../atoms/Dropdown';
import { Form } from 'react-bootstrap';
import { EXPLORERS_JOURNAL } from '../../../../constants/ExplorersJournal.constants';
import { useEffect, useState } from 'react';

function ExplorersJournalHeaderRow({ onCityChange, onTypeChange, locations, types, defaultValue, options }: ExplorersJournalHeaderRowProps) {
  const [locs, setLocs] = useState<Array<{ text: string; value: string }>>([]);
  useEffect(() => {
    if (locations && locations.length) {
      setLocs([{ text: 'All Cities', value: 'all-cities' }, ...locations.map((loc: any) => ({ text: loc.name, value: loc._id }))]);
    }
  }, [locations]);

  return (
    <>
      <div className="explorers-journal-header-row">
        <h3 className="explorers-journal-header-row-title">Explorer's Journal</h3>
        {locs && !!locs.length && (
          <Dropdown
            action={onCityChange}
            inputField
            keyToSet={'text'}
            data={locs}
            defaultValue={defaultValue}
            className="d-flex align-items-center justify-content-between p-2 mt-2 bigger-text-dropdown"
          />
        )}
      </div>
      <div className="explorers-journal-header-row">
        <div className="explorers-journal-header-radios">
          <Form>
            <div key={`inline-radio`} className="mb-3">
              {options.map(opt => (
                <Form.Check
                  inline
                  onChange={onTypeChange}
                  checked={types.includes(opt.value)}
                  value={opt.value}
                  label={opt.label}
                  type={'checkbox'}
                  id={opt.value}
                  className="explorers-journal-header-radios-label pr-3"
                />
              ))}
              {types && options && types.length !== options.length && (
                <span onClick={() => onTypeChange('all')} className="ml-5 pl-3 explorers-journal-header-radios-label pointer">
                  See All
                </span>
              )}
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}

export default ExplorersJournalHeaderRow;
